import axios from 'axios'
var s = window.location.host.split(':')
var host = s[0]
var port = s[1]
switch (port) {
	case '6678': // 本地
	  // host = '60.8.108.18'
	  // port = '56662'
	  host = '192.168.1.244'
	  port = '6677'
	  break
  case '8082': // 本地
    // host = '60.8.108.18'
    // port = '56662'
	host = '192.168.1.244'
    port = '8777'
    break
  case '8076': // 正式
    port = '8077'
    break
  case '8228': // 测试
    port = '8226'
    break
  default:
    break
}

 const adminUrl = 'http://' + host + ':' + port
 const perUrl = 'http://' + host + ':' + port
 const systemUrl = 'http://' + host + ':' + port

export default{
  adminUrl,
  perUrl,
  systemUrl
}



// WEBPACK FOOTER //
// ./src/api/api.js